<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Markvision Enterprise">
     Markvision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_sc" title="修改历史">
     修改历史
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_sc" title="概述">
     概述
    </a>
   </p>
   <div id="divd0e260">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise_sc" title="理解 MarkVision Enterprise">
      理解 MarkVision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter_sc" title="开始">
     开始
    </a>
   </p>
   <div id="divd0e289">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices_sc" title="最佳实践">
      最佳实践
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements_sc" title="系统要求">
      系统要求
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages_sc" title="支持的语言">
      支持的语言
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models_sc" title="支持的打印机型号">
      支持的打印机型号
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database_sc" title="设置数据库">
      设置数据库
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1132" title="设置 run-as 用户">
      设置 run-as 用户
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision_sc" title="安装 MVE">
      安装 MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently_sc" title="无提示安装 MVE">
      无提示安装 MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve_sc" title="访问 MVE">
      访问 MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language_sc" title="更改语言">
      更改语言
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password_sc" title="更改密码">
      更改密码
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter_sc" title="维护应用程序">
     维护应用程序
    </a>
   </p>
   <div id="divd0e1715">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version_sc" title="升级到 MVE 4.3">
      升级到 MVE 4.3
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_sc" title="备份和还原数据库">
      备份和还原数据库
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings_sc" title="安装后更新安装程序设置">
      安装后更新安装程序设置
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter_sc" title="设置用户访问">
     设置用户访问
    </a>
   </p>
   <div id="divd0e1987">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview_sc" title="概述">
      概述
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles_sc" title="理解用户角色">
      理解用户角色
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users_sc" title="管理用户">
      管理用户
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_sc" title="启用 LDAP 服务器身份验证">
      启用 LDAP 服务器身份验证
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_sc" title="安装 LDAP 服务器证书">
      安装 LDAP 服务器证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_sc" title="在 Java 信任库中添加根 CA 证书">
      在 Java 信任库中添加根 CA 证书
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter_sc" title="发现打印机">
     发现打印机
    </a>
   </p>
   <div id="divd0e2401">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile_sc" title="创建发现配置文件">
      创建发现配置文件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles_sc" title="管理发现配置文件">
      管理发现配置文件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_sc" title="示例场景：发现打印机">
      示例场景：发现打印机
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_sc" title="管理安全仪表板">
     管理安全仪表板
    </a>
   </p>
   <div id="divd0e2657">
    <p class="toc-2-style">
     <a href="overview-security-dashboard-topic.html#overview-security-dashboard_sc" title="概述">
      概述
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-dashboard-topic.html#accessing-dashboard_sc" title="访问安全仪表板">
      访问安全仪表板
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-security-information-topic.html#managing-device-security-information_sc" title="管理设备安全信息">
      管理设备安全信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-conformance-check-topic.html#managing-device-conformance-check_sc" title="管理设备一致性检查">
      管理设备一致性检查
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter_sc" title="查看打印机">
     查看打印机
    </a>
   </p>
   <div id="divd0e2766">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list_sc" title="查看打印机列表">
      查看打印机列表
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information_sc" title="查看打印机信息">
      查看打印机信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_sc" title="导出打印机数据">
      导出打印机数据
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views_sc" title="管理视图">
      管理视图
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view_sc" title="更改打印机列表视图">
      更改打印机列表视图
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_sc" title="使用搜索栏筛选打印机">
      使用搜索栏筛选打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords_sc" title="管理关键字">
      管理关键字
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3226" title="使用保存搜索">
      使用保存搜索
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_sc" title="示例场景：监控设备群的碳粉水平">
      示例场景：监控设备群的碳粉水平
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter_sc" title="保护打印机通信">
     保护打印机通信
    </a>
   </p>
   <div id="divd0e4163">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status_sc" title="理解打印机安全状态">
      理解打印机安全状态
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config_sc" title="使用默认配置保护打印机">
      使用默认配置保护打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions_sc" title="理解权限和功能访问控制">
      理解权限和功能访问控制
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security_sc" title="配置打印机安全性">
      配置打印机安全性
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_sc" title="保护设备群中的打印机通信">
      保护设备群中的打印机通信
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers_sc" title="保护打印机的其他方法">
      保护打印机的其他方法
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter_sc" title="管理打印机">
     管理打印机
    </a>
   </p>
   <div id="divd0e4527">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer_sc" title="重新启动打印机">
      重新启动打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews_sc" title="查看打印机&ldquo;嵌入式 Web 服务器&rdquo;">
      查看打印机&ldquo;嵌入式 Web 服务器&rdquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices_sc" title="审核打印机">
      审核打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status_sc" title="更新打印机状态">
      更新打印机状态
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state_sc" title="设置打印机状态">
      设置打印机状态
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_sc" title="分配配置到打印机">
      分配配置到打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations_sc" title="取消配置分配">
      取消配置分配
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations_sc" title="执行配置">
      执行配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance_sc" title="检查打印机与配置的一致性">
      检查打印机与配置的一致性
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers_sc" title="部署文件到打印机">
      部署文件到打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware_sc" title="更新打印机固件">
      更新打印机固件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_sc" title="从打印机卸载应用程序">
      从打印机卸载应用程序
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device_sc" title="分配事件到打印机">
      分配事件到打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword_sc" title="分配关键字到打印机">
      分配关键字到打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_sc" title="将凭证输入到安全打印机">
      将凭证输入到安全打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_sc" title="手动配置默认的打印机证书">
      手动配置默认的打印机证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers_sc" title="移除打印机">
      移除打印机
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter_sc" title="管理配置">
     管理配置
    </a>
   </p>
   <div id="divd0e5133">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview_sc" title="概述">
      概述
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration_sc" title="创建配置">
      创建配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer_sc" title="从打印机创建配置">
      从打印机创建配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_sc" title="示例场景：克隆配置">
      示例场景：克隆配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component_sc" title="从打印机创建高级安全组件">
      从打印机创建高级安全组件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version_sc" title="生成配置设置的可打印版本">
      生成配置设置的可打印版本
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-settings-topic.html#understanding-dynamic-settings_sc" title="理解动态设置">
      理解动态设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings_sc" title="理解变量设置">
      理解变量设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions_sc" title="配置彩色打印权限">
      配置彩色打印权限
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package_sc" title="创建应用程序软件包">
      创建应用程序软件包
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_sc" title="导入或导出配置">
      导入或导出配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library_sc" title="将文件导入资源库">
      将文件导入资源库
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_sc" title="管理证书">
     管理证书
    </a>
   </p>
   <div id="divd0e5644">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5647" title="设置 MVE 来自动管理证书">
      设置 MVE 来自动管理证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5973" title="通过 SCEP 使用 Microsoft 证书颁发机构管理证书">
      通过 SCEP 使用 Microsoft 证书颁发机构管理证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6695" title="通过 MSCEWS 使用 Microsoft 证书颁发机构管理证书">
      通过 MSCEWS 使用 Microsoft 证书颁发机构管理证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7680" title="通过 SCEP 使用 OpenXPKI 证书颁发机构管理证书">
      通过 SCEP 使用 OpenXPKI 证书颁发机构管理证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-EST-group.html#d0e8747" title="通过 EST 使用 OpenXPKI 证书颁发机构管理证书">
      通过 EST 使用 OpenXPKI 证书颁发机构管理证书
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter_sc" title="管理打印机警报">
     管理打印机警报
    </a>
   </p>
   <div id="divd0e9832">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_sc" title="概述">
      概述
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action_sc" title="创建操作">
      创建操作
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders_sc" title="理解操作占位符">
      理解操作占位符
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions_sc" title="管理操作">
      管理操作
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event_sc" title="创建事件">
      创建事件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts_sc" title="理解打印机警报">
      理解打印机警报
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events_sc" title="管理事件">
      管理事件
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter_sc" title="查看任务状态和历史">
     查看任务状态和历史
    </a>
   </p>
   <div id="divd0e10464">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_sc" title="概述">
      概述
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status_sc" title="查看任务状态">
      查看任务状态
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks_sc" title="停止任务">
      停止任务
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs_sc" title="查看日志">
      查看日志
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs_sc" title="清除日志">
      清除日志
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs_sc" title="导出日志">
      导出日志
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks_sc" title="调度任务">
     调度任务
    </a>
   </p>
   <div id="divd0e10572">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule_sc" title="创建时间表">
      创建时间表
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules_sc" title="管理预定任务">
      管理预定任务
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter_sc" title="执行其他管理任务">
     执行其他管理任务
    </a>
   </p>
   <div id="divd0e10714">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings_sc" title="配置常规设置">
      配置常规设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings_sc" title="配置电子邮件设置">
      配置电子邮件设置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer_sc" title="添加登录免责声明">
      添加登录免责声明
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate_sc" title="签署 MVE 证书">
      签署 MVE 证书
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information_sc" title="移除用户信息和引用">
      移除用户信息和引用
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-SSO-chapter.html#managing-SSO-chapter_sc" title="管理 SSO">
     管理 SSO
    </a>
   </p>
   <div id="divd0e10972">
    <p class="toc-2-style">
     <a href="mve-configuration-workflow-adfs-overview-topic.html#d0e10977" title="概述">
      概述
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_sc" title="为 GroupRule 设置声明发布策略">
      为 GroupRule 设置声明发布策略
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_sc" title="为 Name ID 设置声明发布策略">
      为 Name ID 设置声明发布策略
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_sc" title="启用 ADFS 服务器身份验证">
      启用 ADFS 服务器身份验证
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-adfs-topic.html#accessing-mve-adfs_sc" title="通过 ADFS 访问 MVE">
      通过 ADFS 访问 MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="logging-out-mve-adfs-topic.html#logging-out-mve-adfs_sc" title="从 MVE 注销">
      从 MVE 注销
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter_sc" title="常见问题解答">
     常见问题解答
    </a>
   </p>
   <div id="divd0e11142">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions_sc" title="Markvision Enterprise 常见问题解答">
      Markvision Enterprise 常见问题解答
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sc" title="疑难解答">
     疑难解答
    </a>
   </p>
   <div id="divd0e11336">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_sc" title="用户已经忘记密码">
      用户已经忘记密码
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_sc" title="管理员用户已经忘记密码">
      管理员用户已经忘记密码
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_sc" title="页面未加载">
      页面未加载
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_sc" title="不能发现网络打印机">
      不能发现网络打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information_sc" title="不正确的打印机信息">
      不正确的打印机信息
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_sc" title="MVE 没有将打印机识别为安全打印机">
      MVE 没有将打印机识别为安全打印机
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_sc" title="对多个应用程序执行配置在第一次尝试中失败，但在随后的尝试中成功">
      对多个应用程序执行配置在第一次尝试中失败，但在随后的尝试中成功
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_sc" title="使用打印机证书执行配置失败">
      使用打印机证书执行配置失败
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e11553" title="OpenXPKI 证书颁发机构">
      OpenXPKI 证书颁发机构
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="database-access-chapter.html#database-access-chapter_sc" title="数据库访问">
     数据库访问
    </a>
   </p>
   <div id="divd0e11723">
    <p class="toc-2-style">
     <a href="differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_sc" title="在支持的数据库数据类型方面的差异">
      在支持的数据库数据类型方面的差异
     </a>
    </p>
    <p class="toc-2-style">
     <a href="config-item-topic.html#d0e11784" title="FRAMEWORK 表名和字段名">
      FRAMEWORK 表名和字段名
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter_sc" title="附录">
     附录
    </a>
   </p>
   <div id="divd0e17724">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_sc" title="理解端口和协议">
      理解端口和协议
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_sc" title="在 Microsoft CA 中启用证书请求的自动批准">
      在 Microsoft CA 中启用证书请求的自动批准
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates_sc" title="吊销证书">
      吊销证书
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_sc" title="注意事项">
     注意事项
    </a>
   </p>
   <div id="divd0e18100">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18103" title="版本声明">
      版本声明
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18139" title="商标">
      商标
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights_sc" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license_sc" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder_sc" title="许可注意事项">
      许可注意事项
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_sc" title="术语表">
     术语表
    </a>
   </p>
   <div id="divd0e18169">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue